import React from 'react'
import UserMenu from './components/UserMenu'
import ProfilePage from './pages/Profile'
import ChangePassword from './pages/ChangePassword'

export default {
  name: 'iot.user',
  components: {
    'Auth.UserMenu':  UserMenu
  },
  routers: {
    '/app/': [
      {
        path: 'user/profile',
        component: ProfilePage
      },
      {
        path: 'user/changepwd',
        component: ChangePassword
      }
    ]
  },
}
